// Wave 3 — Standard boilerplate Privacy Policy (Owner-editable via /admin/website/content).
import React from "react";
import PublicShell, { usePublicContent } from "../../../components/public/PublicShell";

export default function Privacy() {
  const c = usePublicContent();
  const body = c.legal_privacy_body;
  return (
    <PublicShell>
      <section className="erf-public-section" data-testid="privacy-body">
        <div className="erf-public-container" style={{ maxWidth: 820 }}>
          <div className="erf-public-eyebrow">Legal</div>
          <h1 style={{ marginTop: 12 }}>Privacy Policy</h1>
          {body ? (
            <div style={{ fontSize: 16, lineHeight: 1.7, color: "var(--exec-body)", whiteSpace: "pre-wrap" }}>{body}</div>
          ) : (
            <div style={{ fontSize: 16, lineHeight: 1.7, color: "var(--exec-body)" }}>
              <p>ERF ENTERPRISES LLC ("we," "us") respects your privacy. This Privacy Policy explains what information we collect, how we use it, and your choices.</p>
              <h3 style={{ marginTop: 32 }}>Information we collect</h3>
              <p>When you submit a quote request or contact form, we collect your name, email, phone (optional), project location, and description. We do not use tracking cookies or third-party advertising analytics on this site.</p>
              <h3 style={{ marginTop: 32 }}>How we use it</h3>
              <p>Your information is used solely to respond to your inquiry and manage the resulting project relationship. We do not sell, rent, or share your personal information with third parties for marketing.</p>
              <h3 style={{ marginTop: 32 }}>Data retention</h3>
              <p>Lead inquiries are retained in our audit-tracked customer relationship system for as long as necessary to serve you and comply with legal record-keeping requirements.</p>
              <h3 style={{ marginTop: 32 }}>Security</h3>
              <p>All customer records are stored with strict tenant isolation, encrypted-at-rest credentials for third-party integrations, and immutable audit logging of every consequential change.</p>
              <h3 style={{ marginTop: 32 }}>Your rights</h3>
              <p>You may request access to or deletion of your personal information at any time by contacting us via the contact page.</p>
              <p style={{ marginTop: 40, fontSize: 12, color: "var(--exec-body)", fontStyle: "italic" }}>
                This is a standard-form Privacy Policy placeholder. Edwin may replace this text with a jurisdiction-specific version via <code>/admin/website/content</code> key <code>legal_privacy_body</code>.
              </p>
            </div>
          )}
        </div>
      </section>
    </PublicShell>
  );
}
